import type { FC } from 'react';
import { MenuItem, Select } from '@mui/material';

interface CashListDropdownProps {
  label?: string;
  selectedCashListId: string;
  setSelectedCashListId: (id: string) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
  /**
   * The cash lists to show. Required: pass the full configuration list to
   * deliberately show all.
   */
  cashLists: Array<{
    id: string;
    name: string;
  }>;
}

export const CashListDropdown: FC<CashListDropdownProps> = (props) => {
  return <CashListDropdownView {...props} />;
};

interface CashListDropdownViewProps {
  label?: string;
  selectedCashListId: string;
  setSelectedCashListId: (id: string) => void;
  cashLists: Array<{
    id: string;
    name: string;
  }>;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

export const CashListDropdownView: FC<CashListDropdownViewProps> = ({
  label,
  setSelectedCashListId,
  cashLists,
  selectedCashListId,
  disabled,
  size = 'small',
}) => {
  const singleOption = cashLists.length === 1;
  if (cashLists.length === 0) {
    return null;
  }
  return (
    <Select
      name={'cashListDropdown'}
      label={label}
      value={selectedCashListId}
      onChange={(e) => setSelectedCashListId(e.target.value as string)}
      sx={{ width: 150 }}
      disabled={disabled || singleOption}
      size={size}
    >
      {cashLists.map((cashList) => (
        <MenuItem key={cashList.id} value={cashList.id}>
          {cashList.name}
        </MenuItem>
      ))}
    </Select>
  );
};
